import StarFilled from 'public/icons/icn-star-rating.svg';
import StarEmpty from 'public/icons/icn-star-rating-empty.svg';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  productImage?: string;
  sellerName?: string;
  rating: number;
  hovered: number;
  setRating: (r: number) => void;
  setHovered: (h: number) => void;
};

const RateView = ({ productImage, sellerName, rating, hovered, setRating, setHovered }: Props) => {
  const { t } = useTranslation();

  // Touch browsers replay hover events during a tap and may drop the tap's click when the
  // hover handler mutates the DOM, so hover preview must stay desktop-only (DEV-2254).
  const supportsHover = useMemo(() => typeof window !== 'undefined' && window.matchMedia('(hover: hover)').matches, []);

  return (
    <div className="item-received-rate-view">
      {productImage && <img src={productImage} alt="" className="item-received-rate-view__image" />}

      <p className="item-received-rate-view__title">{t('components.feedback.rate-experience-title', { name: sellerName })}</p>

      <p className="item-received-rate-view__subtitle">{t('components.feedback.click-to-rate')}</p>

      <div className="item-received-rate-view__stars">
        {Array.from({ length: 5 }, (_, i) => i + 1).map((star) => {
          const active = star <= (hovered || rating);
          const Star = active ? StarFilled : StarEmpty;

          return (
            <button
              key={star}
              type="button"
              aria-label={t(`components.feedback.rating.${star}`)}
              className="item-received-rate-view__star-button"
              onClick={() => setRating(star)}
              onMouseEnter={supportsHover ? () => setHovered(star) : undefined}
              onMouseLeave={supportsHover ? () => setHovered(0) : undefined}
            >
              <Star
                className={active ? 'item-received-rate-view__star' : 'item-received-rate-view__star item-received-rate-view__star-empty'}
              />
            </button>
          );
        })}
      </div>

      <p className="item-received-rate-view__rating-label">
        {hovered || rating ? t(`components.feedback.rating.${hovered || rating}`) : ''}
      </p>
    </div>
  );
};

export default RateView;
